/*! Wi-modal - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */
var url_modals;
+function ($) {
    'use strict';
    var wiModal = window.wiModal;
    window.wiModal = {
        init: function () {
            $(document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function () {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });
            $(document).on('shown.bs.modal', '.modal', function (event) {
                $(this).find('[autofocus]').focus();
                if ($('#fileupload').length) {
                    $("#fileupload table tbody.files").empty();
                }
                var self = $(this);
                $(this).on('click', '.btn-download', function () {
                    self.modal('hide');
                });
            });
            $(document).on('hidden.bs.modal', '.modal', function () {
                if ($(this).attr('data-remove') === 'true') {
                    $(this).remove();
                }
                $('.modal:visible').length && $(document.body).addClass('modal-open');
            });
            $(document).on('show.bs.modal', '.modal-max-height', function () {
                $(this).show();
                wiModal.setMaxHeight(this);
            });
            $(window).resize(function () {
                if ($('.modal-max-height.in').length !== 0) {
                    wiModal.setMaxHeight($('.modal-max-height.in'));
                }
            });
            $(document).on('hide.bs.modal,hidden.bs.modal', function () {
                $('body').css('padding-right', '0');
            });
        },
        refresh: function (id) {
            wiImages.refresh();
            wiPlugins.refresh();
        },
        setMaxHeight: function (element) {
            this.$element = $(element);
            this.$content = this.$element.find('.modal-content');
            var borderWidth = this.$content.outerHeight() - this.$content.innerHeight();
            var dialogMargin = $(window).width() < 768 ? 20 : 60;
            var contentHeight = $(window).height() - (dialogMargin + borderWidth);
            //var headerHeight = this.$element.find('.modal-header').outerHeight() || 0;
            //var footerHeight = this.$element.find('.modal-footer').outerHeight() || 0;
            //var maxHeight = contentHeight - (headerHeight + footerHeight);
            var maxHeight = contentHeight;
            this.$content.css({
                'overflow': 'hidden'
            });
            this.$element
                    .find('.modal-scroll').css({
                'max-height': maxHeight,
                'overflow-y': 'auto'
            });
        },
        get: function (options) {
            var defaults = {
                csrf_wicode: $('input[name=csrf_wicode]').val()
            };
            var main_data = $.extend({}, defaults, options);
            var id = '#' + main_data.modal;
            if (id === '#view_media_file') {
                id = '#view_media';
            }
            $.ajax({
                type: 'get',
                url: url_modals,
                data: main_data,
                success: function (response) {
                    if (response.status === 'ok') {
                        if (!$('.wicode-modal' + id).length) {
                            $('body').append(response.modal);
                        } else if (id === '#view_media') {
                            $('.wicode-modal' + id + ' .modal-dialog').html(response.modal);
                            wiComments.get.comments();
                        }
                        wiModal.refresh(id);
                        if (!$('.wicode-modal' + id).hasClass('in')) {
                            $('.wicode-modal' + id).modal('show');
                        }
                    }
                }
            });
        },
        post: function (options) {
            var defaults = {
                csrf_wicode: $('input[name=csrf_wicode]').val()
            };
            var main_data = $.extend({}, defaults, options);
            var id = '#' + main_data.modal;
            if (id === '#view_media_file') {
                id = '#view_media';
            }
            $.ajax({
                type: 'post',
                url: url_modals,
                data: main_data,
                success: function (response) {
                    if (response.status === 'ok') {
                        if (!$('.wicode-modal' + id).length) {
                            $('body').append(response.modal);
                        } else if (id === '#view_media') {
                            $('.wicode-modal' + id + ' .modal-dialog').html(response.modal);
                            wiComments.get.comments();
                        }
                        wiModal.refresh(id);
                        if (!$('.wicode-modal' + id).hasClass('in')) {
                            $('.wicode-modal' + id).modal('show');
                        }
                    }
                }
            });
        }
    };
    $(function () {
        url_modals = urls.modals;
        wiModal = window.wiModal;
        wiModal.init();
    });
}(jQuery);
